import { render, staticRenderFns } from "./StockRoom.vue?vue&type=template&id=5f62df4a&"
import script from "./StockRoom.vue?vue&type=script&lang=js&"
export * from "./StockRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports